import { Component, OnInit } from '@angular/core';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiMobileAppHelperService } from '@fi-app/utilities/fi-services/mobile-app-helper.service';
import { UrlService } from '@uirouter/angular';
import { AppTextService } from '@fi-shared/app-text';
import { LoadingService } from '@fi-app/shared/fi-loading/loading.service';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { FiLogErrorService } from '@fi-shared/fi-shared-services/fi-log-error.service';

@Component({
    selector: 'fi-authenticate-login-token',
    template: '',
    standalone: false,
})
export class FiAuthenticateLoginTokenComponent implements OnInit {
    constructor(
        private stateService: FiStateService,
        private mobileAppHelperService: FiMobileAppHelperService,
        private urlService: UrlService,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
        private fiLoadingService: LoadingService,
        private logErrorService: FiLogErrorService,
    ) {}

    ngOnInit() {
        const url = (function (stateService) {
            if (stateService.params.url) {
                return decodeURIComponent(stateService.params.url);
            }
            if (stateService.params._d) {
                const data = JSON.parse(decodeURIComponent(stateService.params._d));
                return stateService.href(data.state, data.stateParams);
            }
            return '/';
        })(this.stateService);

        if (!url) {
            this.fiLoadingService.finishLoading();
            this.logErrorService.logError('Wrong data for LoginToken');

            this.fiDialogsService.error().afterClosed(() => {
                this.mobileAppHelperService.closeIFrame();
            });

            /*
            this.fiDialogsService.notify({
                messageText: this.appTextService.get('common.update_app_description'),
                yesButtonText: this.appTextService.get('common.update_app')
            }).afterClosed(() => {
                //this.mobileAppHelperService.openUpdateAppLink();
            });
*/
            return;
        }
        this.mobileAppHelperService.setMobileAppMode(url);

        setTimeout(() => this.urlService.url(url, true));
    }
}
